import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, BookOpen } from "lucide-react";
import Logo from "../components/Logo";
import LanguageSwitcher from "../components/LanguageSwitcher";
import ChatPanel from "../components/ChatPanel";
import { useApp } from "../context/AppContext";
import { t } from "../lib/i18n";

export default function Guide() {
  const { lang } = useApp();
  return (
    <div className="relative z-10 min-h-screen flex flex-col">
      <div className="sticky top-0 z-20 glass-strong border-b border-[rgba(210,170,80,0.3)] px-4 md:px-6 py-2.5 flex items-center gap-3">
        <Logo size="sm" />
        <span className="flex-1 text-center font-display text-xl md:text-2xl font-semibold text-[var(--gold-deep)]">{t(lang, "guideTitle")}</span>
        <div className="hidden md:block"><LanguageSwitcher variant="pills" /></div>
        <Link to="/read" className="btn-ghost-gold rounded-full px-3 py-2 text-sm flex items-center gap-1.5"><BookOpen size={15} /><span className="hidden sm:inline">{t(lang, "readBible")}</span></Link>
      </div>

      <div className="flex-1 flex flex-col items-center px-4 py-6">
        <Link to="/" className="self-start inline-flex items-center gap-2 text-sm text-[var(--gold-deep)] hover:underline mb-4">
          <ArrowLeft size={16} /> {t(lang, "backHome")}
        </Link>
        <p className="text-center text-[var(--ink-soft)] font-scripture text-lg max-w-xl mb-4">{t(lang, "guideIntro")}</p>
        <div className="w-full max-w-2xl flex-1 min-h-0" style={{ height: "70vh" }}>
          <ChatPanel compact={false} />
        </div>
      </div>
    </div>
  );
}
